export default function currentLanguage() {
    const params = new URLSearchParams(window.location.search);
    let lang = params.get('lang');
    if (lang && lang === 'en') {
        return 'en'
    } else {
        return 'bg'
    }
}